import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Modal } from '../../modules/Modal';

import { Page } from './Page';

export class Front extends Page {
    public static render(params: RouteParams): void {
        this._initOwlCarousel();
    }
    private static _initOwlCarousel(): void {
        const carouselItems = $('.item-slider.view-unformatted__item');
        carouselItems.parents('.view-unformatted__row').addClass('owl-theme').addClass('owl-carousel');
        carouselItems.addClass('item');
        carouselItems.parents('.view-unformatted__row').owlCarousel({
            loop: true,
            margin: 0,
            nav: true,
            dots: true,
            autoplay: true,
            autoplayTimeout: 5000,
            autoplayHoverPause: true,
            mouseDrag: true,
            touchDrag: true,
            singleItem: true,
            responsive: {
                0: {
                    items: 1,
                },
            },
        });
    }
}
